<template>
  <!-- <div style="height: auto;width: 100%;" class="cargo-advance-search customs-file-search-condition">
    <div class="cargo-advance-search-header">
      <div class="cargo-advance-search-quick" style="width: 100%">
        <div class="section form-row"> -->
  <!-- <el-form
            label-position="left"
            style="width: 100%;"
            :inline="true"
            :label-width="isZh ? '75px' : '105px'"
          >
            <el-form-item :label="$t('SeaExport.CustomsNo')">
              <el-input v-model="filter.customsNo" :placeholder="$t('SeaExport.PleaseScanTheBarcodeOrInputDirectly')" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SoNo')">
              <el-input v-model="filter.soNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Mbl2')">
              <el-input v-model="filter.mbl" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Status')">
              <el-select
                v-model="filter.state"
              >
                <el-option
                  v-for="(item,index) in fileStates"
                  :key="index"
                  :label="isZh ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CollectionSituation')">
              <el-select
                v-model="filter.clearState"
              >
                <el-option
                  v-for="(item,index) in gatherType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_TradeTerm"
                :default-value="filter.tradeTerm"
                style="width: 100%"
                @parentCallBack="p=>{filter.tradeTerm=p.value}"
              />
            </el-form-item>
          </el-form>
          <el-form
            label-position="left"
            style="width: 100%;"
            :inline="true"
            :label-width="isZh ? '75px' : '105px'"
          >
            <el-form-item :label="$t('SeaExport.BusinessNo')">
              <el-input v-model="filter.jobNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NCReferenceNo')" :label-width="isZh ? '95px' : '105px'">
              <el-input v-model="filter.agentRefNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Customer')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{customer:true}"
                :default-value="filter.customerId"
                style="width: 100%"
                @parentCallBack="p=>{filter.customerId=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperatingCompany')">
              <el-input v-model="filter.companyCName" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{customsBroker:true, seaExport:true}"
                :default-value="filter.customsBroker"
                style="width: 100%"
                @parentCallBack="p=>{filter.customsBroker=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.RecordCount')">
              <el-input v-model="filter.pageSize" />
            </el-form-item>
            <el-form-item v-show="openXhqCustomsAll" :label="$t('CargoMsg.XhqCustomerState')" :label-width="isZh ? '105px' : '125px'">
              <el-select v-model="filter.xhqCustomState" no="xhqCustomState" :clearable="true">
                <el-option value="0" :label="$t('CargoMsg.NotSendingCustomerFile')" />
                <el-option value="1" :label="$t('CargoMsg.CustomerFileHasBeenSent')" />
                <el-option value="3" :label="$t('CargoMsg.LCLTaskSent')" />
              </el-select>
            </el-form-item>
            <el-form-item v-show="openXhqCustomsAll" :label="$t('CargoMsg.CustomsUnFrozen')">
              <el-select v-model="filter.customsUnfrozenState" no="customsUnfrozenState" :clearable="true">
                <el-option value="0" :label="$t('CargoMsg.NotUnfreeze')" />
                <el-option value="1" :label="$t('CargoMsg.Unfreeze')" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-form
            label-position="left"
            style="width: 100%;"
            :inline="true"
            :label-width="isZh ? '75px' : '105px'"
          >
            <el-form-item :label="$t('SeaExport.DocumentDate')">
              <div style="display: flex">
                <el-select v-model="filter.dateType" style="width: 122px">
                  <el-option
                    v-for="(item,index) in dateTypes"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-date-picker
                  v-model="filter.minDate"
                  type="date"
                  style="width:122px;"
                  value-format="yyyy-MM-dd"
                />
                <span style="margin-right: 5px; margin-left: 5px;">{{ $t('Pricing.EndDate') }}</span>
                <el-date-picker
                  v-model="filter.maxDate"
                  type="date"
                  style="width:122px;"
                  value-format="yyyy-MM-dd"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DepartureTime')">
              <div style="display: flex">
                <el-date-picker
                  v-model="filter.minEtd"
                  type="date"
                  style="width:122px;"
                  value-format="yyyy-MM-dd"
                />
                <span style="margin-right: 5px; margin-left: 5px;">{{ $t('Pricing.EndDate') }}</span>
                <el-date-picker
                  v-model="filter.maxEtd"
                  type="date"
                  style="width:122px;"
                  value-format="yyyy-MM-dd"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CommodityInspectionOrNot')">
              <el-select
                v-model="filter.commodityInspection"
              >
                <el-option
                  v-for="(item,index) in yesOrNot"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsInspectionOrNot')">
              <el-select
                v-model="filter.spotInspection"
              >
                <el-option
                  v-for="(item,index) in yesOrNot"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsStatus')">
              <el-select
                v-model="filter.customsStatus"
                clearable
              >
                <el-option
                  v-for="(item,index) in customsStateList"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBrokerStatus')">
              <el-select
                v-model="filter.customsBrokerStatus"
                clearable
              >
                <el-option
                  v-for="(item,index) in customsBrokerStateList"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-checkbox v-model="isAppend">{{ $t('SeaExport.AppendQueryRecord') }}</el-checkbox>
          </el-form> -->
  <search-item
    config-module="20220112"
    :reset="true"
    :is-append-query="true"
    :custom-search-items="customSearchItems"
    :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
    @simSearchItemCallBack="toSimpleQuery"
    @advSearchItemCallBack="toAdvancedQuery"
  >
    <template slot="operations">
      <!-- <el-button type="primary" @click="toQuery">{{ $t('SeaExport.Search') }}</el-button> -->
      <el-button type="primary" @click="addBtnClickHandler">{{ $t('SeaExport.New') }}</el-button>
      <el-button type="primary" @click="editClickHandler">{{ $t('SeaExport.Edit') }}</el-button>
      <el-button type="primary" @click="batchSaveClickHandler">{{ $t('SeaExport.BatchSaving') }}</el-button>
      <el-button type="primary" @click="backListBtn_clickHandler">{{ $t('SeaExport.RetreatASingle') }}</el-button>
      <el-button type="primary" @click="gatherBtn_clickHandler">{{ $t('SeaExport.CollectFormation') }}</el-button>
      <el-button type="primary" @click="btnPrint_clickHandler()">{{ $t('SeaExport.print') }}</el-button>
      <el-button type="primary" @click="btnBatchState_clickHandler()">{{ $t('SeaExport.BatchStateTransition') }}</el-button>
      <el-select v-model="batchState" style="width: 122px; margin-left: 5px; margin-right: 5px">
        <el-option
          v-for="(item,index) in batchStates"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <!-- <el-button type="primary" @click="resetSearch()">{{ $t('SeaExport.ResetFilter') }}</el-button> -->
      <el-button type="primary" @click="clearGridHandler()">{{ $t('SeaExport.EmptyTheList') }}</el-button>
      <el-button type="primary" @click="backStateEventHandler()">{{ $t('SeaExport.StateOfTheWithdrawal') }}</el-button>
      <el-button v-show="openXhqCustomsAll" no="xhqCustomsUnFrozen" type="primary" @click="xhqCustomsUnFrozenHandler">{{ $t('CargoMsg.UnFrozen') }}</el-button>
      <el-button v-show="openXhqCustomsAll" no="xhqCustomsUnFrozen" type="primary" @click="xhqOpenChatPage">{{ $t('CargoMsg.OpenXhqChat') }}</el-button>
    </template>
  </search-item>
  <!-- </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import StrUtils from '@/utils/StrUtils'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import * as FileState from '@/class/cargo/model/parameters/FileState'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import checkPermission from '@/utils/permission'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants.js'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'

export default {
  name: 'CustomsFileSearchCondition',
  components: { CargoAdvanceSelect, CargoUserSelect, searchItem, AdvancedSearchOption },
  props: {
    filter: {
      type: Object, default: () => {
        return {
          clearState: -1,
          spotInspection: -1,
          commodityInspection: -1,
          state: 100,
          tradeTerm: '',
          pageSize: 100
        }
      }
    }
  },
  data() {
    return {
      fileStates: [],
      selectTypeNames: TYPE_NAMES,
      isAppend: false,
      fileState: '',
      batchState: '',
      batchStates: [],
      gatherType: [{ label: this.$t('CargoMsg.Cargo_CollectedInFull'), value: 1 }, { label: this.$t('CargoMsg.Cargo_NotCollectedInFull'), value: 0 }],
      yesOrNot: [{ label: this.$t('SeaExport.All'), value: -1 },
        { label: this.$t('SeaExport.Yes'), value: 1 },
        { label: this.$t('SeaExport.No'), value: 0 }],
      dateTypes: [{ label: this.$t('SeaExport.SendingDate'), value: 'SEND_DATE' },
        { label: this.$t('SeaExport.DateOfOrder'), value: 'ACCEPTED_DATE' },
        { label: this.$t('SeaExport.dateOfFiling'), value: 'FILED_DATE' },
        { label: this.$t('SeaExport.RefundDate'), value: 'REBATED_DATE' },
        { label: this.$t('SeaExport.ReceivingDate'), value: 'BACK_DATE' },
        { label: this.$t('SeaExport.ReturnDate'), value: 'RETURN_DATE' },
        { label: this.$t('SeaExport.DateOfCreation'), value: 'INPUT_DATE' },
        { label: this.$t('SeaExport.DateOfCustomsDeclaration'), value: 'CUSTOMS_DATE' }],
      xinHaoQiApi: 0,
      customsStateList: SystemConstants.CUSTOMS_STATUS,
      customsBrokerStateList: SystemConstants.CUSTOMS_BROKER_STATUS,
      customSearchItems: []
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    openXhqCustomsAll() {
      return this.xinHaoQiApi === 2
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.xinHaoQiApi = Number(cache.config.get('xinHaoQiApi'))
      const fileState = []
      // fileState.push(FileState.ALL_TYPE)
      fileState.push(FileState.NCD_TYPE)
      this.fileStates = fileState.concat(FileState.FILE_STATES)
      this.initBatchStatesRole()

      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'file.STATE'
      searchField.itemLabel = 'SeaExport.Status'
      searchField.tagName = this.isZh ? 'chineseName' : 'englishName'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 1
      searchField.dataProvider = this.fileStates
      this.customSearchItems.push(searchField.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'charge.PAID_OFF'
      searchField.itemLabel = 'SeaExport.CollectionSituation'
      searchField.tagName = 'label'
      searchField.tagValue = 'value'
      searchField.defaultSelected = 1
      searchField.dataProvider = this.gatherType
      this.customSearchItems.push(searchField.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'customsInfo.CUSTOMS_STATUS'
      searchField.itemLabel = 'SeaExport.CustomsStatus'
      searchField.tagName = 'chineseName'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 1
      searchField.dataProvider = this.customsStateList
      this.customSearchItems.push(searchField.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'customsInfo.CUSTOMS_BROKER_STATUS'
      searchField.itemLabel = 'SeaExport.CustomsBrokerStatus'
      searchField.tagName = 'chineseName'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 1
      searchField.dataProvider = this.customsBrokerStateList
      this.customSearchItems.push(searchField.formatObj2Json())

      if (this.openXhqCustomsAll) {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect'
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'seaJob.XHQ_CUSTOM_STATE'
        searchField.itemLabel = 'CargoMsg.XhqCustomerState'
        searchField.tagName = 'label'
        searchField.tagValue = 'value'
        searchField.defaultSelected = 1
        searchField.dataProvider = [
          { value: 0, label: this.$t('CargoMsg.NotSendingCustomerFile') },
          { value: 1, label: this.$t('CargoMsg.CustomerFileHasBeenSent') },
          { value: 3, label: this.$t('CargoMsg.LCLTaskSent') }
        ]
        this.customSearchItems.push(searchField.formatObj2Json())

        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect'
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'customsInfo.CUSTOMS_UNFROZEN_STATE'
        searchField.itemLabel = 'CargoMsg.CustomsUnFrozen'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL]
        searchField.tagName = 'label'
        searchField.tagValue = 'value'
        searchField.defaultSelected = 1
        searchField.dataProvider = [
          { value: 0, label: this.$t('CargoMsg.NotUnfreeze') },
          { value: 1, label: this.$t('CargoMsg.Unfreeze') }
        ]
        this.customSearchItems.push(searchField.formatObj2Json())
      } else {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        searchField.itemType = 'advanceSelect'
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'seaJob.XHQ_CUSTOM_STATE'
        this.customSearchItems.push(searchField.formatObj2Json())

        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        searchField.itemType = 'advanceSelect'
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'customsInfo.CUSTOMS_UNFROZEN_STATE'
        this.customSearchItems.push(searchField.formatObj2Json())
      }
    },
    checkState() {
      return (this.filter.minDate == null && this.filter.maxDate == null && this.filter.customsNo && this.filter.soNo)
    },
    initBatchStatesRole() {
      const batchStates = []
      batchStates.push(this.createStateItem(this.$t('SeaExport.SentOut'), 1))
      if (this.hasPermission('Back') || this.hasPermission('Orders')) {
        batchStates.push(this.createStateItem(this.$t('SeaExport.TakenOver'), 10))
      }
      if (this.hasPermission('Pigeonhole')) {
        batchStates.push(this.createStateItem(this.$t('SeaExport.Filed'), 11))
      }
      if (this.hasPermission('TaxRebate')) {
        batchStates.push(this.createStateItem(this.$t('SeaExport.TaxRefunded'), 12))
      }
      if (this.hasPermission('Orders')) {
        batchStates.push(this.createStateItem(this.$t('SeaExport.ReturnedbyOurCompany'), 2))
      }
      if (this.hasPermission('Orders')) {
        batchStates.push(this.createStateItem(this.$t('SeaExport.ReturnedtoTheCustomer'), 3))
      }
      this.batchStates = batchStates
    },
    hasPermission(point) {
      return checkPermission(['role_fmSEFile_' + point])
    },
    createStateItem(label, value) {
      return { label, value }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      let data
      if (typeof keyword !== 'undefined') {
        data = [
          new AdvancedSearchOption(null, 'job.JOB_NO', keyword, 'LIKE').formatObj2Json()
        ]
      }
      this.toAdvancedQuery(data)
    },
    // 高级查询
    async toAdvancedQuery(data) {
      this.$emit('advSearchItemResetCallBack', data)
    },
    toQuery() {
      this.proxy = {}
      const { name, ownerId } = this.filter
      if (!StrUtils.isEmpty(name)) {
        this.proxy['name'] = name
      }
      if (ownerId && ownerId > 0) {
        this.proxy['ownerId'] = ownerId
      }
      this.proxy['isLimited'] = true
      this.$emit('advSearchItemResetCallBack', this.proxy)
    },
    resetSearch() {
      this.filter = PriceUtils.resetFilter(this.filter)
      this.filter.state = 100
      this.filter.clearState = -1
      this.filter.spotInspection = -1
      this.filter.commodityInspection = -1
      this.filter.tradeTerm = ''
      this.filter.agentRefNo = ''
    },
    clearCustomsNo() {
      this.filter.customsNo = ''
    },
    getBatchFileState() {
      return this.batchState
    },
    addBtnClickHandler() {
      this.$emit('add')
    },
    editClickHandler() {
      this.$emit('edit')
    },
    batchSaveClickHandler() {
      this.$emit('batchSave')
    },
    backListBtn_clickHandler() {
      this.$emit('backList')
    },
    gatherBtn_clickHandler() {
      this.$emit('gather')
    },
    btnPrint_clickHandler() {
      this.$emit('print')
    },
    btnBatchState_clickHandler() {
      this.$emit('batchState')
    },
    clearGridHandler() {
      this.$emit('clearData')
    },
    backStateEventHandler() {
      this.$emit('backState')
    },
    xhqCustomsUnFrozenHandler() {
      this.$emit('unFrozen')
    },
    xhqOpenChatPage() {
      this.$emit('openChatPage')
    }
  }
}
</script>

<style lang="scss">
.customs-file-search-condition{
  input.el-input__inner{
    width: 100% !important;
  }
  .el-row {
    margin-right: 5px !important;
  }
}
</style>
